import validator from 'validator';

class FormValidator {
	constructor(language) {
		// Defines validation rules for given fields
		this.validations = [
			{
				field: 'currentheating',
				method: 'isEmpty',
				validWhen: false,
				messageEnglish: 'Please select your current heating solution',
				messageFrench: 'Veuillez sélectionner votre solution de chauffage actuelle'
			}, {
				field: 'annualspend',
				method: 'isEmpty',
				validWhen: false,
				messageEnglish: 'Please enter your annual spending amount',
				messageFrench: 'Veuillez entrer votre montant de dépenses annuel'
			}, {
				field: 'annualspend',
				method: 'matches',
				args: [/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/],
				validWhen: true,
				messageEnglish: 'Please enter an amount between 0 and 20000',
				messageFrench: 'Veuillez entrer un montant valide supérieur de zéro'
			}, {
				field: 'annualspend',
				method: 'matches',
				args: [/^([1-9]\d{0,3}|1\d{4}|20000)$/],
				validWhen: true,
				messageEnglish: 'Please enter an amount between 0 and 200000',
				messageFrench: 'Veuillez entrer un montant de dépense valide'
			}, {
				field: 'province',
				method: 'isEmpty',
				validWhen: false,
				messageEnglish: 'Please select a valid province',
				messageFrench: 'Veuillez sélectionner une province valide'
			}, {
				field: 'firstname',
				method: 'isEmpty',
				validWhen: false,
				messageEnglish: 'Please enter a valid name',
				messageFrench: 'Veuillez entrez un nom valide'
			}, {
				field: 'lastname',
				method: 'isEmpty',
				validWhen: false,
				messageEnglish: 'Please enter a valid name',
				messageFrench: 'Veuillez entrez un nom valide'
			}, {
				field: 'emailaddress',
				method: 'isEmpty',
				validWhen: false,
				messageEnglish: 'Please enter a valid email',
				messageFrench: 'Veuillez entrer un email valide'
			}, {
				field: 'emailaddress',
				method: 'isEmail',
				validWhen: true,
				messageEnglish: 'Please enter a valid email',
				messageFrench: 'Veuillez entrer un email valide'
			}, {
				field: 'postalcode',
				method: 'isEmpty',
				validWhen: false,
				messageEnglish: 'Please enter a postal code',
				messageFrench: 'Veuillez entrer un code postal'
			}, {
				field: 'postalcode',
				method: 'matches',
				args: [/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/],
				validWhen: true,
				messageEnglish: 'Please enter a valid postal code',
				messageFrench: 'Veuillez entrer un code postal valide'
			}, {
				field: 'caslcheck',
				method: 'equals',
				args: ['true'],
				validWhen: true,
				messageEnglish: 'This is a required field.',
				messageFrench: 'Ce champ est obligatoire'
			}
		];

		this.validations.map((item) => {
			if (language === 'fr') {
				item.message = item.messageFrench;
			} else {
				item.message = item.messageEnglish;
			}
			return item;
		})
	}

	validate(state) {
		// start out assuming valid
		let validation = this.valid();

		// for each validation rule
		this.validations.forEach(rule => {

			// if the field hasn't already been marked invalid by an earlier rule
			if (!validation[rule.field].isInvalid) {
				// determine the field value, the method to invoke and optional args from
				// the rule definition
				const field_value = state[rule.field].toString();
				const args = rule.args || [];
				const validation_method = typeof rule.method === 'string'
					? validator[rule.method]
					: rule.method

				// call the validation_method with the current field value as the first
				// argument, any additional arguments, and the whole state as a final
				// argument.  If the result doesn't match the rule.validWhen property,
				// then modify the validation object for the field and set the isValid
				// field to false
				if (validation_method(field_value, ...args, state) !== rule.validWhen) {
					validation[rule.field] = {
						isInvalid: true,
						message: rule.message
					}
					validation.isValid = false;
				}
			}
		});

		return validation;
	}

	valid() {
		const validation = {};

		this.validations.map(rule => (validation[rule.field] = {
			isInvalid: false,
			message: ''
		}));

		return {
			isValid: true,
			...validation
		};
	}
}

export default FormValidator;



// WEBPACK FOOTER //
// ./src/validation/FormValidator.js